<template>
    <div class="contact_icon" id="contact_icon">
        <div class="phone" id="phone">
            <label></label>
            <p class="p">电&nbsp;话</p>
            <div class="phone_cover" id="phone_cover">
                <p>电话咨询</p>
                <span>400-607-6006</span>
            </div>
        </div>
        <div class="wx" id="wx">
            <label></label>
            <p class="p">微&nbsp;信</p>
            <div class="wx_cover" id="wx_cover">
                <p>微信咨询</p>
                <p class="wx_img">
                    <img src="https://cdn.kuailework.com/images/klwk/public/icon_kefu.png " alt="" />
                </p>

            </div>
        </div>
        <!-- <div class="phone" id="yx">
            <label></label>
            <p class="p">邮&nbsp;箱</p>
            <div class="phone_cover" id="yx_cover">
                <p>邮箱咨询</p>
                <span>zhen.wang@soucaigroup.com</span>
            </div>
        </div> -->
        <div class="return_top" id="goToTop" @click="returnTop">
            <img src="https://cdn.kuailework.com/images/website/images/index/icon_fanhuidingbu.png" alt="" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "linkBar",
        methods:{
            returnTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
                // var ksHeight = document.documentElement.offsetHeight;
                // var scrollT =
                //     document.documentElement.scrollTop || document.body.scrollTop;
                // var scrollH = document.body.scrollHeight;
                // if (ksHeight + scrollT >= scrollH + 100) {
                //     window.scrollBy(0, -ksHeight);
                // }
            },
        },
        mounted(){
            window.addEventListener("scroll", ()=>{
                let top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                console.log(top)
                if (top >= 60) {
                    document.getElementById("goToTop").style.display = "flex";
                }else{
                    document.getElementById("goToTop").style.display = "none";
                }
            }, false);
        }
    }
</script>

<style scoped>
    .contact_icon {
        position: absolute;
        right: 0;
        transition: top 1s;
        z-index: 9;
        display: none;
        width: 66px;
        /* height: 243px; */
        background: #FFFFFF;
        box-shadow: 0px 4px 12px 2px rgba(170,192,216,0.52);
        border-radius: 6px 0px 0px 6px;
        position: fixed;
        display: block;
        transition: top 0.5s ease 0s;
        bottom: 280px;
    }
    .contact_icon div {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        justify-items: center;
        cursor: pointer;
        width: 100%;
        color: #333;
        height: 80px;
        border-bottom: 1px solid #e3e3e3;
        cursor: pointer;
    }
    .contact_icon div.wx_cover {
        border: none;
    }
    .contact_icon div.phone_cover {
        border: none;
    }
    .contact_icon div img {
        width: 30px;
        height: 30px;
        margin-top: 14px;
        cursor: pointer;
    }

    .contact_icon div .wx_cover img {
        width: 89%;
        height: 73%;
        margin-left: 5px;
    }

    .contact_icon .wx {
        /* margin-bottom: 2px; */
    }

    .contact_icon .wx .p {
        color: #fff;
        font-size: 14px;
        /* position: absolute; */
        bottom: 7px;
        left: 21px;
    }

    .contact_icon .wx div {
        display: none;
        /* display: inline-block; */
        position: absolute;
        z-index: 99999;
        top: 24px;
        left: -160px;
        background: #fff;
        box-sizing: border-box;
        overflow: hidden;
        width: 260px;
        height: 324px;
    }

    .contact_icon .wx div {
        width: 155px;
        height: 173px;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px #DCDCDC;
        border-radius: 4px;
        text-align: center;
        padding: 16px 20px;
    }

    .contact_icon .wx div p {
        float: left;
        width: 100%;
        text-align: center;
        font-size: 14px;
        /* margin-top: 40px; */
    }
    .contact_icon .wx div p.wx_img {
        width: 115px;
        height: 115px;
        background: #D8D8D8;
        border-radius: 2px;
        text-align: center;

        /* margin-top: 20px !important; */
    }
    .contact_icon .wx div p.wx_img img {
        width: 100%;
        height: 100%;
        margin: 0 auto;
    }
    .contact_icon .phone .p {
        color: #fff;
        font-size: 14px;
        /* position: absolute; */
        bottom: 7px;
        left: 21px;
    }

    .contact_icon .phone div {
        display: none;
        /* display: inline-block; */
        position: absolute;
        z-index: 99999;
        top: 24px;
        left: -185px;
        background: #fff;
        box-sizing: border-box;
        overflow: hidden;
        width: 260px;
        height: 324px;
    }

    .contact_icon .phone div {
        width: 180px;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px #DCDCDC;
        text-align: center;
        padding: 16px 0;
        border-radius: 4px;
    }

    .contact_icon .phone div p {
        float: left;
        width: 100%;
        text-align: center;
        font-size: 14px;
        /* margin-top: 40px; */
    }

    .contact_icon .phone div img {
        /* float: left; */
        width: 200px;
        height: 200px;
        margin-top: 20px;
        /* margin-right: 5px; */
        /* margin-left: 14px; */
    }
    .contact_icon div p {
        color: #333 !important;
        font-size: 14px;
        margin-top: 6px;
    }
    .contact_icon div span {
        display: inline-block;
        margin-top: 6px;
        font-size: 12px;
        color: #0CAB04;
    }
    .contact_icon div.return_top {
        width: 70px;
        height: 50px;
        background: linear-gradient(90deg, #228d4a, #05a30b);
        border-radius: 0px 0px 2px 2px;
        border: none;
        cursor: pointer;
        text-align: center;
        display: none;
    }
    .contact_icon div.return_top img {
        width: 15px;
        height: 22px;
        margin-top: 0px;
    }
    .contact_icon .phone label {
        background: url(https://cdn.kuailework.com/images/officialWebsite/index/sidebar_phone_normal.png);
        width: 28px;
        height: 28px;
    }
    .contact_icon .wx label {
        background: url(https://cdn.kuailework.com/images/officialWebsite/index/sidebar_wechat_normal.png);
        width: 30px;
        height: 25px;
    }
    #yx label {
        background: url(https://cdn.kuailework.com/images/officialWebsite/index/sidebar_email_normal.png);
        width: 28px;
        height: 21px;
    }
    #phone:hover .phone_cover{
        display: block;
    }
    .contact_icon #wx{
        cursor: pointer;
    }
    .contact_icon #yx{
        border-bottom: none;
    }
    .contact_icon #phone:hover label{
        background: url(https://cdn.kuailework.com/images/officialWebsite/index/sidebar_phone_selected.png);
    }
    .contact_icon #wx:hover label{
        background: url(https://cdn.kuailework.com/images/officialWebsite/index/sidebar_wechat_selected.png);
    }
    .contact_icon #yx:hover label{
        background: url(https://cdn.kuailework.com/images/officialWebsite/index/sidebar_email_selected.png);
    }
    #wx:hover #wx_cover{
        display: block;
    }
    #yx:hover #yx_cover{
        display: block;
    }
    .contact_icon .phone:hover .p {
        color: #0CAB04 !important;
    }
    .contact_icon .wx:hover .p {
        color: #0CAB04 !important;
    }
</style>